<template>
  <div class="login">
    <!-- <img
      src="../assets/imgs/login/backGroundImg.png"
      alt
      style="width: 100%"
    />-->
    <div class="content">
      <div class="LoginBox">
        <div class="loginText">
          <div class="top">信用财富，助力普惠金融</div>
          <div class="bottom">服务实体 / 防范风险 / 便利快捷</div>
        </div>
        <div class="loginDialog" v-if="loginDialog">
          <div class="loginTop">欢迎登录</div>
          <div class="input" style="display: flex; flex-direction: column">
            <el-select
              v-model="value"
              style="margin-top: 25px; width: 100%"
              prefix-icon="el-icon-user-solid"
              class="xuanze"
              @change="cli_choose"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
            <div
              v-if="
               loginForm.sourceType === '2'||loginForm.sourceType === '3' || loginForm.sourceType === '4'||loginForm.sourceType === '5'||loginForm.sourceType === '6'
              "
              style="display: flex; flex-direction: column"
            >
              <el-form
                autocomplete="on"
                :model="loginForm"
                ref="loginForm"
                label-position="left"
                style="height: 100px; display: flex; flex-direction: column;"
              >
                <el-input
                  placeholder="输入手机号"
                  name="loginName"
                  type="text"
                  v-model="loginForm.loginName"
                  autocomplete="off"
                  clearable
                  class="user"
                ></el-input>
                <el-input
                  placeholder="输入密码"
                  @keyup.enter.native="handleLogin"
                  v-model="loginForm.password"
                  class="password"
                  type="password"
                ></el-input>
              </el-form>
              <div class="register">
                <!-- <div class="registered" @click="registered" >立即注册</div> -->
                <div class="forgotPassword">忘记密码</div>
              </div>
              <el-button class="submit" type="primary" round @click.native.prevent="handleLogin">登录</el-button>
            </div>
            <!-- 企业的立即注册 -->
            <div v-if="
                loginForm.sourceType === '1' 
              ">
              <div >
                  <el-form
                    autocomplete="on"
                    :model="loginForm"
                    ref="loginForm"
                    label-position="left"
                    style="display: flex; flex-direction: column"
                  >
                    <el-input
                      placeholder="输入手机号"
                      name="loginName"
                      type="text"
                      v-model="loginForm.loginName"
                      autocomplete="off"
                      clearable
                      class="user"
                    ></el-input>
                    <el-input
                      placeholder="输入密码"
                      @keyup.enter.native="handleLogin"
                      v-model="loginForm.password"
                      class="password"
                      type="password"
                    ></el-input>
                  </el-form>
                  <el-form style="display: flex; gap: 12px;">
                    <el-input
                      placeholder="输入验证码"
                      v-model="loginForm.phoneCode"
                      class="phoneCode"
                      type="text"
                    ></el-input>
                    <el-button 
                      class="getCodeBtn"
                      type="primary" 
                      round 
                      :disabled="isCounting"
                      @click.native.prevent="handleGetCode"
                    >
                      {{ isCounting ? `${countdown}秒后重新获取` : '获取验证码' }}
                    </el-button>
                  </el-form>
                </div>
              <div style="display: flex;justify-content: space-between">
                <div style="width:170px;">
                  <div class="register2">
                    <div class="registered" @click="registered" >立即注册</div>
                    <!-- <div class="forgotPassword">忘记密码</div> -->
                  </div>
                  <el-button class="submit" type="primary" round @click.native.prevent="handleLogin">登录</el-button>
                </div>
                <div style="width: 1px;height: auto;border-right: solid 1px #dcdfe6;margin: 6px 0;"></div>
                <div style="display: flex;flex-direction: column;justify-content: center;margin-top: auto;">
                  <div class="register2">
                    <div class="registered" style="cursor: pointer" @click="userlogin()">苏商通注册</div>
                  </div>
                  <el-button class="submit" style="width: 170px;" type="primary" @click="userlogin()">苏商通登录</el-button>
                </div>
              </div>
            </div>
            <div
              v-if="
                loginForm.sourceType === '1' 
              "
              class="fyappcode"
            >
              <img src="../assets/fangyi/loginappcode.png" alt />
              <span>手机下载“苏商通”APP</span>
            </div>
          </div>
        </div>
        <div class="loginDialog1" v-if="registere">
          <div class="loginTop1">用户注册</div>
          <div class="box">
            <el-form
              :model="registereFrom"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
              :inline="false"
            >
              <!-- <el-form-item prop="sourceType">
                <el-select
                  v-model="registereFrom.sourceType"
                  placeholder="选择用户类型"
                  style="width: 100%"
                  @change="seleChange"
                >
                  <el-option label="企业用户" value="1"></el-option>
                  <el-option label="金融机构" value="2"></el-option>
                  <el-option label="审核人" value="3"></el-option>
                  <el-option label="监管机构" value="4"></el-option>
                  <el-option label="银行授权书" value="5"></el-option>
                  <el-option label="信用中心" value="6"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item prop="organization" v-if="registereFrom.sourceType == 2">
                <el-select
                  v-model="registereFrom.organization"
                  placeholder="金融机构所属银行"
                  style="width: 100%"
                  @change="changeBlank"
                >
                  <el-option
                    v-for="item in finbankList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.unisc_id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="deptId" v-if="registereFrom.sourceType == 4">
                <el-select v-model="registereFrom.deptId" placeholder="所属区县" style="width: 100%">
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="organization" v-if="registereFrom.sourceType == 5">
                <el-select
                  v-model="registereFrom.organization"
                  placeholder="所属银行"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in bankList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.unisc_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="name">
                <el-input v-model="registereFrom.name" placeholder="请输入用户姓名" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item prop="mobilePhone">
                <el-input v-model="registereFrom.mobilePhone" maxlength="11" placeholder="请输入手机号码"></el-input>
              </el-form-item>
              <el-form-item
                prop="password"
                :style="
                  spanStatus ? 'margin-bottom:0px;' : 'margin-bottom:20px;'
                "
              >
                <el-input v-model="registereFrom.password" placeholder="输入密码" show-password></el-input>
                <span
                  v-if="spanStatus"
                  style="
                    font-size: 12px;
                    margin: 5px 0 0 5px;
                    font-family: Alibaba PuHuiTi;
                    font-weight: 400;
                  "
                >6-16位，需包含大小写字母和数字</span>
              </el-form-item>
              <el-form-item prop="secondPassword">
                <el-input v-model="registereFrom.secondPassword" show-password placeholder="确认密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
                <el-button
                  type="primary"
                  style="margin-left: 70px"
                  @click="submitForm('ruleForm')"
                >立即创建</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  superviseLogin,
  Register,
  getRoleInfo,
  getBankInfo,
  zxBankLogin,
  getfinBankInfo
} from "@/api/login";
import currentEnv from "../utils/envSetting";
import { getSmsSend } from "@/api/login";

export default {
  name: "login",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    let validPassword = (rule, value, callback) => {
      let reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,20}$/;
      if (!reg.test(value)) {
        this.spanStatus = false;
        callback(new Error("密码必须是由6-16位字母+数字组合"));
      } else {
        this.spanStatus = true;
        callback();
      }
    };
    let secondPassword = (rule, value, callback) => {
      if (this.registereFrom.password == "") {
        callback(new Error("请先输入密码"));
      } else if (this.registereFrom.password !== "") {
        if (this.registereFrom.password == value) {
          callback();
        } else if (value == "") {
          callback(new Error("请输入确认密码"));
        } else if (this.registereFrom.password !== value) {
          callback(new Error("两次密码不一致"));
        }
      }
    };
    return {
      spanStatus: true,
      options: [
        {
          value: "1",
          label: "企业用户"
        }
        // {
        //   value: "2",
        //   label: "金融机构"
        // }, //互联网用1 ,2
        // {
        //   value: "3",
        //   label: "审核人"
        // },
        // {
        //   value: "4",
        //   label: "监管机构"
        // },
        // {
        //   value: "5",
        //   label: "银行授权书"
        // },
        // {
        //   value: "6",
        //   label: "信用中心"
        // }
        //政务外网 把options里的1,2注释
        //互联网   把把options里的的3,4注释
      ],
      value: "1", //政务外网 改为3 互联网为1
      activeIndex: "/xyd/home",
      loginForm: {
        loginName: "",
        password: "",
        phoneCode: "",//验证码
        sourceType: "1" //政务外网 改为3 互联网为1
      },
      loading: false,
      // 验证码倒计时相关
      countdown: 60,
      isCounting: false,
      pwdType: "password",
      loginUrl: "",
      registere: false,
      loginDialog: true,
      registereFrom: {
        name: "",
        sourceType: 1,
        mobilePhone: "",
        password: "",
        secondPassword: "",
        deptId: "",
        organization: ""
      },
      registereType: [
        {
          value: "1",
          label: "审核人"
        }
        // {
        //   value: "2",
        //   label: "监管机构"
        // }
      ],
      finbankList: [],
      typeList: [],
      bankList: [],
      rules: {
        name: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
          { min: 1, max: 20, message: "长度在1到4个字", trigger: "blur" }
        ],
        sourceType: [
          { required: true, message: "请选择用户类型", trigger: "change" }
        ],
        mobilePhone: [{ validator: checkPhone, trigger: "blur" }],
        password: [{ validator: validPassword, trigger: "blur" }],
        secondPassword: [{ validator: secondPassword, trigger: "blur" }],
        deptId: [{ required: true, message: "请选择区县", trigger: "change" }],
        organization: [
          { required: true, message: "请选择所属银行", trigger: "change" }
        ]
      }
    };
  },

  created() {
    // if (location.href.indexOf("#reloaded") == -1) {
      
      // location.href = location.href + "#reloaded";
      // location.reload();
      try{
        let {params} = this.$route.query;
        if( params !=undefined ){
        // 直接跳转首页
          const res = zxBankLogin({params});
          Promise.resolve(res).then(result => {
            //处理返回的Promise
            if (result.data.code == 200) {
              sessionStorage.setItem(
                "loginTime",
                result.data.data.userWebVo.loginTime
              );
              this.$store.commit(
                "organization",
                result.data.data.userWebVo.organization
              );
              this.loading = false;
              sessionStorage.setItem("token", result.data.data.token);
              sessionStorage.setItem(
                "phone",
                result.data.data.userWebVo.mobilePhone
              );
              sessionStorage.setItem("deptId", result.data.data.userWebVo.deptId);
              this.$store.commit(
                "setSourceType",
                result.data.data.userWebVo.sourceType
              );
              this.$store.commit("setUserName", result.data.data.userWebVo.name);
              sessionStorage.setItem("currentTab", "AuthManagementSearch");
              this.$router.push("/xyd/my_center");
              this.$emit("myChange");
            } else {
              this.$message.error(result.msg);
            }
          });
        }
      }catch{

      }
    // }
    this.getRoleInfo();
    this.getcurrentEnv();
  },
  methods: {
    handleGetCode(){
      //获取验证码
      if (this.isCounting) return;
      
      // 验证手机号
      if (!this.loginForm.loginName) {
        this.$message.warning('请先输入手机号');
        return;
      }
      
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
      if (!reg.test(this.loginForm.loginName)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      
      // 开始倒计时
      this.isCounting = true;
      this.countdown = 60;
      
      // 模拟获取验证码请求
      getSmsSend({
        phone: this.loginForm.loginName,
        type: 1
      }).then(res => {
        if (res.data.code == 200) {
          this.$message.success('验证码已发送');
        } else {
          this.$message.error(res.msg);
        }
      });
      
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
          this.isCounting = false;
          this.countdown = 60;
        }
      }, 1000);
    },
    // 当前环境
    getcurrentEnv() {
      switch (currentEnv) {
        case 1:
          this.options = [
            {
              value: "1",
              label: "企业用户"
            },
            // {
            //   value: "2",
            //   label: "金融机构"
            // }, //互联网用1 ,2
            // {
            //   value: "3",
            //   label: "审核人"
            // },
            // {
            //   value: "4",
            //   label: "监管机构"
            // },
            // {
            //   value: "5",
            //   label: "银行授权书"
            // },
            // {
            //   value: "6",
            //   label: "信用中心"
            // }
          ];
          this.value = "1";
          this.loginForm.sourceType = "1";
          break;
        case 2:
          this.options = [
            {
              value: "1",
              label: "企业用户"//调登录注册苏商通
            },
            // {
            //   value: "2",
            //   label: "金融机构"
            // }, //互联网用1 ,2
            // {
            //   value: "3",
            //   label: "审核人"
            // },
            // {
            //   value: "4",
            //   label: "监管机构"
            // },
            // {
            //   value: "5",
            //   label: "银行授权书"
            // },
            // {
            //   value: "6",
            //   label: "信用中心"
            // }
          ];
          this.value = "1";
          this.loginForm.sourceType = "1";
          break;
        case 3:
          this.options = [
            {
              value: "3",
              label: "审核人"
            },
            {
              value: "4",
              label: "监管机构"
            }
          ];
          this.value = "3";
          this.loginForm.sourceType = "3";
          break;
        default:
          break;
      }
    },
    getRoleInfo() {
      let params = {
        parent: 4
      };
      getRoleInfo(this.sendParam(params))
        .then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.typeList = res.data;
          }
        })
        .catch(error => {});
    },

    // 给deptId赋值
    changeBlank(valCode) {
      // 根据选中的 bank_code 查找对应的银行对象
      const selectedBank = this.finbankList.find(
        item => item.bank_code === valCode
      );
      if (selectedBank) {
        this.registereFrom.deptId = selectedBank.bank_id;
      }
    },
    //获取金融机构银行
    async getfinBankInfo() {
      const res = await getfinBankInfo();
      this.finbankList = res.data.data;
    },
    // 获取银行
    async getBankInfo() {
      const res = await getBankInfo();
      this.bankList = res.data.data;
      this.finbankList =  res.data.data;
    },
    // 用户注册的选项
    seleChange(val) {
      if (val == 2) {
        this.registereFrom.organization = "";
        this.getBankInfo();
      } else if (val == 5) {
        this.registereFrom.organization = "";
        this.getBankInfo();
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          Register(this.sendParam(this.registereFrom)).then(res => {
            res = this.paramDecrypt(res);
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.registere = false;
              this.loginDialog = true;
            } else if (res.code == 202) {
              this.$message.error(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //审核人监管机构注册
    registered() {
      this.loginDialog = false;
      this.registere = true;
    },
    cli_choose(e) {
      this.loginForm.sourceType = e;
    },
    goPath(path) {
      this.$router.push(path);
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          let param = {
            loginName: this.loginForm.loginName,
            password: this.loginForm.password,
            sourceType: this.loginForm.sourceType,
            phoneCode: this.loginForm.phoneCode
          };
          let randomStr = this.randomString(16);
          let body = {
            requestData: this.AesEncrypt(JSON.stringify(param), randomStr),
            encrypted: this.RsaEncrypt(randomStr)
          };
          const res = superviseLogin(body);
          Promise.resolve(res).then(value => {
            //处理返回的Promise
            let key = this.RsaDecrypt(value.data.encrypted);
            let result = JSON.parse(
              this.AesDecrypt(value.data.requestData, key)
            );
            if (result.code == 200) {
              sessionStorage.setItem(
                "loginTime",
                result.data.userWebVo.loginTime
              );
              // sessionStorage.setItem(
              //   "organization",
              //   result.data.userWebVo.organization
              // );
              this.$store.commit(
                "organization",
                result.data.userWebVo.organization
              );
              this.loading = false;
              sessionStorage.setItem("token", result.data.token);
              sessionStorage.setItem(
                "phone",
                result.data.userWebVo.mobilePhone
              );
              sessionStorage.setItem("deptId", result.data.userWebVo.deptId);
              this.$store.commit(
                "setSourceType",
                result.data.userWebVo.sourceType
              );
              if(result.data.userWebVo.sourceType=="2"||result.data.userWebVo.sourceType=="5"){
                sessionStorage.setItem("currentTab", "AuthManagementSearch"); //设置2 5 角色 个人中心是信用数据查询页面
              }
              this.$store.commit("setUserName", result.data.userWebVo.name);
              this.$router.push({
                path: "/xyd/index"
              });
              this.$emit("myChange");
            } else {
              this.$message.error(result.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    userlogin() {
      //========================================================================================================
      if (currentEnv == 1) {
        // 测试环境用这个
        this.$router.push({
          name: "xydindex",
          // path: '/xyd/index',
          query: {
            code: this.loginForm.sourceType === "2" ? "jinrongjigou" : undefined
          },
          params: {
            status: true
          }
        });
      } else {
        // ========================================================================================================

        // let paramurl = "http://2.46.5.101:8084/#/xyd/index"; //测试环境
        //
        // let paramurl = "https://credit.suzhou.com.cn/#/xyd/index"; //生产正式环境
        // a132e77e-b76a-4b4e-a85c-e20384e0d45c
        let paramurl =
          "https://credit.suzhou.com.cn/#/xyd/index";
        let encodedParam = encodeURIComponent(paramurl);
        let url = `https://sst.suzhou.gov.cn/sst-smartcity-sso/frame/pages/login/memlogin?response_type=code&redirect_uri=${encodedParam}&client_id=44d6f0c6-1559-41aa-9cc2-a4a684399606  `;
        window.open(url, "_self");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.login {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  // height: calc(100vh - 30px);
  height: 907px;
  min-width: 100%;
  background-image: url(../assets/imgs/login/backGroundImg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .content {
    width: 100%;
    height: 100%;
    .LoginBox {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 456px;
      width: 1314px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .loginText {
        .top {
          height: 61px;
          text-shadow: 10px 10px 10px 10px #ccc;
          font-size: 64px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #ffffff;
        }
        .bottom {
          height: 35px;
          font-size: 37px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #ffffff;
          margin-top: 36px;
        }
      }
      .fyappcode {
        margin-top: 20px;
        display: flex;
        align-items: center;
        span {
          font-weight: 500;
          color: #2981ee;
          font-size: 23px;
          margin-left: 25px;
        }
      }
      .loginDialog {
        width: 430px;
        height: auto;
        background-color: #f7f7f7;
        padding: 33px;
        border-radius: 4px;
        box-sizing: border-box !important;

        .loginTop {
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2981ee;
          margin: 0 auto;
          text-align: center;
        }

        .input {
          box-sizing: border-box !important;
          .xuanze {
            /deep/ .el-input__inner {
              background-size: 16px 16px !important;
              background-position: 11px 11px !important;
              padding: 0 0 0 36px;
              box-sizing: border-box;
              font-size: 14px;
              background: url(../assets/icon/user.png) no-repeat;
            }
          }
          .userPwd {
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            /deep/ .el-form {
              box-sizing: border-box;
            }
          }
          .user {
            margin-top: 25px;

            /deep/ .el-input__inner {
              background-size: 16px 16px !important;
              background-position: 11px 11px !important;
              padding: 0 0 0 36px;
              box-sizing: border-box;
              font-size: 14px;
              background: url(../assets/icon/phone.png) no-repeat;
            }
          }

          .password {
            margin-top: 25px;

            /deep/ .el-input__inner {
              background-size: 16px 16px !important;
              background-position: 11px 11px !important;
              padding: 0 0 0 36px;
              box-sizing: border-box;
              font-size: 14px;
              background: url(../assets/icon/password.png) no-repeat;
            }
          }
          .phoneCode {
            flex: 1;
            margin-top: 25px;

            /deep/ .el-input__inner {
              background-size: 16px 16px !important;
              background-position: 11px 11px !important;
              padding: 0 0 0 36px;
              box-sizing: border-box;
              font-size: 14px;
              // background: url(../assets/icon/phoneCode.png) no-repeat;
            }
          }
        }
      }
      .loginDialog1 {
        width: 330px;
        height: auto;
        background-color: #f7f7f7;
        padding: 33px;
        border-radius: 4px;
        box-sizing: border-box !important;

        .loginTop1 {
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2981ee;
          margin: 0 auto;
          text-align: center;
        }
        .box {
          margin-top: 20px;
          box-sizing: border-box !important;

          /deep/ .el-form {
            margin: 0 auto;
            width: 250px;
            // .el-input {
            //   width: 117%;
            // }
          }
          /deep/ .el-form-item__content {
            margin-left: 0px !important;
          }
        }
        .btn {
          width: 100%;
          display: flex;
          justify-content: space-around;
        }
      }
      .register {
        display: flex;
        justify-content: flex-end;
        height: 18px;
        font-size: 15px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #93969c;
        margin-top: 44px;

        .registered {
          padding-right: 5px;
          cursor: pointer;
        }

        .forgotPassword {
          padding-left: 5px;
          //border-left: 2px solid #93969c;
        }
      }
      .register2 {
        display: flex;
        justify-content: flex-end;
        height: 18px;
        font-size: 15px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #93969c;
        margin-top: 15px;

        .registered {
          padding-right: 5px;
          cursor: pointer;
        }

        .forgotPassword {
          padding-left: 5px;
          //border-left: 2px solid #93969c;
        }
      }

      .submit {
        width: 100%;
        margin-top: 14px;
        border-radius: 4px;
      }
      .getCodeBtn {
        margin-top: 25px;
        width: 140px;
        border-radius: 4px;
        font-size: 14px;
        
        &:disabled {
          background-color: #ccc !important;
          border-color: #ccc !important;
          cursor: not-allowed;
        }
      }
    }
  }
}

.bottomPart {
  width: 100%;
  height: 80px;
  position: absolute;
  top: 41px;
  left: 0;
  background: url("../assets/images/header_bg.png");
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;

  .leftPart {
    margin-left: 300px;

    .title {
      color: #fff;
      font-weight: bold;
      font-size: 28px;
    }

    .info {
      color: #fff;
      font-size: 14px;
      margin-top: 6px;
    }
  }

  .rightPart {
    margin-right: 300px;
  }
}

/deep/ .el-menu {
  background: unset;
  border-bottom: unset !important;

  .el-menu-item {
    font-size: 18px;
    color: #fff !important;
    padding: 0;
    margin: 0 20px;
    border-bottom: unset;

    &:hover,
    &:focus {
      background: unset !important;
      color: #fff !important;
    }

    a {
      text-decoration: none;
      vertical-align: unset;
    }
  }

  .el-submenu {
    margin: 0 20px;
    box-sizing: border-box;
    height: 60px;

    .el-submenu__title {
      font-size: 18px;
      color: #fff !important;
      padding: 0;
      border-bottom: unset !important;

      &:hover,
      &:focus {
        background: unset;
        color: #fff;
      }

      i {
        display: none;
      }
    }
  }

  .is-active {
    border-bottom: 3px solid #fff !important;
  }
}
</style>